// The report editor's font and font-size pickers. Admins and facility admins always had them; a user who can
// edit reports (Save role, e.g. a facility physician who edits and signs) gets them too, so a doctor correcting an
// uploaded report can change its font (Jessica, 2026-10-24). They only take effect while the report text is
// editable; read-only reports stay read-only.
export const canChangeReportFont = (auth) =>
    !!auth && (auth.isInRole('Admin') === true || auth.isInRole('FacilityAdmin') === true || auth.isInRole('Save') === true);



// WEBPACK FOOTER //
// ./src/utils/reportFontControls.js